import React, { useState, useEffect } from "react";
import { Image_Url } from '../../constants/imageUrl/ImageUrl'
import "./header.scss";
import Cookies from "js-cookie";
import { IoIosMenu } from "react-icons/io";
import { safeDecode } from "../../common/decoder";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { logoutAction } from "../../actions/logoutAction";

function Header({ toggleSidebar, menuButtonRef  }) {
  const [showLogout, setShowLogout] = useState(false);
  const [isLogoutButtonClick, setIsLogoutButtonClick] = useState(false);
  const role = safeDecode(Cookies.get('role')) ? `${safeDecode(Cookies.get("role"))}` : null;
  const { t } = useTranslation();
  const countryFlag = localStorage.getItem('countryFlag')
  const countryName = localStorage.getItem('countryName')

  const handleUserImageClick = () => {
    setShowLogout(!showLogout);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = async () => {
    setIsLogoutButtonClick(true);
    let response = await dispatch(logoutAction());
    if (response?.data?.success === true) {
      Cookies.remove('accessToken');
      Cookies.remove('role');
      Cookies.remove('permissions');
      Cookies.remove('admin_user_id')
      Cookies.remove('country_id');
      Cookies.remove('country_name');
      Cookies.remove('currency');
      Cookies.remove('access_token');
      Cookies.remove('language');
      localStorage.clear('countryName')
      NotificationManager.success(response?.data?.message);
      setIsLogoutButtonClick(false);
      navigate("/");
      window.location.reload();
    } else if (response === undefined) {
      setIsLogoutButtonClick(false);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const profileTextImage = document.querySelector(".profile_text_image");
      if (profileTextImage && !profileTextImage.contains(event.target)) {
        setShowLogout(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="header_container">
      <div className="header_main">
        <button ref={menuButtonRef} onClick={toggleSidebar} className="menu-button">
          <IoIosMenu size={24} />
        </button>
        <img
          src={Image_Url.TVSLOGO}
          className="tvs_logos" />
        <span className="profile_text_image">
          <span className="country-display"><img src={countryFlag} className="country-flag" alt="country-flag" /><span className="country-name">{countryName?.toUpperCase()}</span></span>
          <img src={Image_Url.PERSONALPROFILE} onClick={handleUserImageClick} />
          <span>{role?.charAt(0).toUpperCase() + role?.slice(1).toLowerCase()}</span>
          {showLogout && (
            <button className="logout_button active logout_flex" disabled={isLogoutButtonClick} onClick={handleLogout}>
              <img className="logout_btn" src={Image_Url.LOGOUTICON} alt="logout_icon" />
              {t('common.logout')}
            </button>
          )}
        </span>
      </div>
    </div>
  );
}

export default Header;
